import { render } from "./gradesheetbatch.vue?vue&type=template&id=0ef1c4d8"
import script from "./gradesheetbatch.vue?vue&type=script&lang=js"
export * from "./gradesheetbatch.vue?vue&type=script&lang=js"

import "./gradesheetbatch.vue?vue&type=style&index=0&id=0ef1c4d8&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__